import React from "react";

const Joker: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 288.155 288.155" {...props}>
    <path
      fill="currentColor"
      d="M268.716 115.677c-10.702 0-19.378 8.649-19.434 19.337-23.02-.545-45.599 6.505-66.54 17.426l-32.435-95.787c7.676-2.599 13.208-9.846 13.208-18.4 0-10.736-8.703-19.439-19.439-19.439s-19.439 8.703-19.439 19.439c0 8.554 5.532 15.801 13.208 18.4l-32.474 95.903c-20.929-10.91-43.492-17.95-66.497-17.406l.002-.035c0-10.736-8.703-19.439-19.439-19.439S0 124.38 0 135.116s8.703 19.439 19.439 19.439c6.321 0 11.92-3.031 15.471-7.703 13.722 11.857 32.076 37.776 35.311 92.514-8.053.264-14.505 6.858-14.505 14.975 0 8.284 6.716 15 15 15H217.44c8.284 0 15-6.716 15-15 0-8.12-6.456-14.716-14.513-14.975 3.208-54.749 21.53-80.705 35.257-92.596 3.547 4.72 9.174 7.786 15.533 7.786 10.736 0 19.439-8.703 19.439-19.439-.001-10.737-8.704-19.44-19.44-19.44z"
    />
  </svg>
);

export default Joker;
